const lightTheme = {
    bg: '#fff',
    text: '#121212',
};

const darkTheme = {
    bg: '#121212',
    text: '#fff',
};

const themes = { lightTheme, darkTheme };

export default themes;
